import { generatePath } from 'react-router-dom';
import { PLAYLIST_URL_FRAGMENT } from '../../constants/Navigation';
export const getPlaylistUrl = playlistId => {
  const pathname = generatePath(PLAYLIST_URL_FRAGMENT, {
    playlistId
  });
  const search = '';
  return {
    search,
    pathname,
    hash: '',
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};